"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.I18NContext = React.createContext({
    gettext: v => v,
    localeObj: {}
});
//# sourceMappingURL=context.js.map